import gql from 'graphql-tag';

export const SpeciesFragments = {
  id: gql`
    fragment SpeciesId on Species {
      _id: externalId
    }
  `,
};
